export default "__VITE_ASSET__44f62ad7__"